import { ContextUsage } from "@design";
import type { ContextInfoData } from "@/api";
import { useContextUsageLabels } from "@/components/designLabels";
import { formatCompact } from "@/i18n/format";

/** The last reply's context-window usage (power-user setting `show_context_info`), under the composer. */
export function ChatContextUsage({ info }: Readonly<{ info: ContextInfoData }>) {
  const labels = useContextUsageLabels();
  return (
    <ContextUsage
      labels={labels}
      formatTokens={formatCompact}
      contextWindow={info.context_window ?? 0}
      maxOutputTokens={info.max_output_tokens ?? 0}
      toolTokens={info.tool_tokens ?? 0}
      budget={info.budget ?? 0}
      promptTokens={info.prompt_tokens ?? 0}
      percentUsed={info.percent_used ?? 0}
      messagesLoaded={info.messages_loaded ?? 0}
      messagesAfterTrim={info.messages_after_trim ?? 0}
      model={info.model ?? ""}
      groupsPruned={info.groups_pruned ?? 0}
      groupsTrimmed={info.groups_trimmed ?? 0}
      summarized={info.summarized ?? false}
    />
  );
}
